import { render, staticRenderFns } from "./RecipeTop.vue?vue&type=template&id=bb2bc9e8&scoped=true"
import script from "./RecipeTop.vue?vue&type=script&lang=js"
export * from "./RecipeTop.vue?vue&type=script&lang=js"
import style0 from "./RecipeTop.vue?vue&type=style&index=0&id=bb2bc9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2bc9e8",
  null
  
)

export default component.exports